import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Importation du Link
import './css/header.css';
import './css/typography.css';

const HeaderSection = ({ scrollToSection }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 900);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      className="background-photo"
      style={{
        backgroundImage: "url('/image/valentin-leverrier-ingenieur-son.webp')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        position: 'relative',
      }}
    >
      <div className="fuzzy-overlay"></div>
      <img
        src="/image/valentin-leverrier-ingenieur-son.webp"
        alt="Preload"
        style={{ display: 'none' }}
        loading="eager"
      />

      <div className="white-band">
        <div className="text-left">
          {/* Le titre devient un lien vers la page Home */}
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            <h1 className="header-title">Valentin Leverrier</h1>
          </Link>
          {isMobile && <hr className="mobile-separator" />}
          <h4>Ingénieur son, Perchman Doc | Reportage TV | Clips</h4>
          <h4>2e Assistant son Fiction Long / Quotidienne</h4>
          <h4>1e Assistant son Court</h4>
          {isMobile && <hr className="mobile-separator" />}
        </div>
        {/* Barre de navigation (affichée en desktop uniquement) */}
        {!isMobile && (
          <div className="sections">
            <h6 className="clickable" onClick={() => scrollToSection('presentation')}>
              Présentation
            </h6>
            <h6 className="clickable" onClick={() => scrollToSection('material')}>
              Matériel
            </h6>
            <h6 className="clickable" onClick={() => scrollToSection('experience')}>
              Expérience
            </h6>
            <h6 className="clickable" onClick={() => scrollToSection('media')}>
              Médias
            </h6>
          </div>
        )}
        <div className="social-icons">
          <a href="mailto:valentin.leverrier@gmail.com">
            <img src="/image/mail.webp" alt="Mail" loading="lazy" />
          </a>
          <a href="tel:+33610381216">
            <img src="/image/phone.webp" alt="Téléphone" loading="lazy" />
          </a>
          <a
            href="https://www.instagram.com/fousound/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="/image/insta.webp" alt="Instagram" loading="lazy" />
          </a>
        </div>
      </div>

      {/* Flèche invitant à descendre (uniquement sur smartphone) */}
      {isMobile && (
        <div
          className="scroll-arrow"
          onClick={() => scrollToSection('presentation')}
        >
          &#x2193;
        </div>
      )}
    </div>
  );
};

export default HeaderSection;
